module.exports = __webpack_public_path__ + "assets/img/Lottery_tit.c72807f5.png";